"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownBarItem = void 0;
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var styles = __importStar(require("./dropdown-bar-item.scss"));
var preact_render_to_string_1 = require("preact-render-to-string");
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var a11y_wrapper_1 = require("@playkit-js/common/dist/hoc/a11y-wrapper");
var _a = kaltura_player_js_1.ui.Components, Icon = _a.Icon, Tooltip = _a.Tooltip;
var PADDING = 11;
var DropdownBarItem = function (_a) {
    var displayName = _a.displayName, text = _a.text, ariaLabel = _a.ariaLabel, isDisabled = _a.isDisabled, icon = _a.icon, onClick = _a.onClick, onDropdownClick = _a.onDropdownClick, tooltipPosition = _a.tooltipPosition;
    var comparisonTextRef = (0, hooks_1.useRef)(null);
    var textRef = (0, hooks_1.useRef)(null);
    var _b = __read((0, hooks_1.useState)(false), 2), showTooltip = _b[0], setShowTooltip = _b[1];
    var _c = __read((0, hooks_1.useState)(false), 2), isFinalized = _c[0], setIsFinalized = _c[1];
    (0, hooks_1.useLayoutEffect)(function () {
        if (!isFinalized && (textRef === null || textRef === void 0 ? void 0 : textRef.current) && (comparisonTextRef === null || comparisonTextRef === void 0 ? void 0 : comparisonTextRef.current)) {
            setIsFinalized(true);
            var textWidth = (textRef === null || textRef === void 0 ? void 0 : textRef.current.getBoundingClientRect().width) - PADDING;
            var comparisonTextWidth = comparisonTextRef === null || comparisonTextRef === void 0 ? void 0 : comparisonTextRef.current.getBoundingClientRect().width;
            setShowTooltip(comparisonTextWidth > textWidth);
        }
    });
    var renderIcon = function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return (0, preact_1.h)(Icon, { type: icon.type, id: displayName, path: icon.path, viewBox: icon.viewBox || '0 0 32 32' });
    };
    var textElement = ((0, preact_1.h)("span", { className: [styles.dropdownItemDescription, showTooltip ? styles.trimText : ''].join(' '), ref: textRef }, text));
    var comparisonTextElement = ((0, preact_1.h)("span", { ref: comparisonTextRef, className: styles.comparisonText }, text));
    var content = !isFinalized ? ((0, preact_1.h)(preact_1.Fragment, null,
        textElement,
        comparisonTextElement)) : (textElement);
    var ariaLabelString = typeof ariaLabel === 'string' ? ariaLabel : (0, preact_render_to_string_1.renderToString)(ariaLabel);
    var renderContent = function () {
        return ((0, preact_1.h)(a11y_wrapper_1.A11yWrapper, { onClick: function (e) {
                onClick(e);
                onDropdownClick();
            }, role: "menuitem" },
            (0, preact_1.h)("div", { className: [styles.dropdownItem, isDisabled ? styles.disabled : ''].join(' '), tabIndex: 0, "aria-label": ariaLabelString },
                (0, preact_1.h)("div", { className: styles.icon }, renderIcon()),
                content)));
    };
    return ((0, preact_1.h)(preact_1.Fragment, null, showTooltip ? (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (0, preact_1.h)(Tooltip, { label: text, type: tooltipPosition, className: styles.moreItemTooltip }, renderContent())) : (renderContent())));
};
exports.DropdownBarItem = DropdownBarItem;
